/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Name_LabelInputs */



/**
* | output |
* | --- |
* | "List Name" |
*
* @param {Markers_List_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_name_label = /** @type {((inputs?: Markers_List_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom de la liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Listenname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nome elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Название списка")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nombre de la lista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("列表名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("リスト名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नाम की सूचि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nome da lista")
	return /** @type {LocalizedString} */ ("List Name")
});